import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import { TEditCustomerDetailsReduxParams } from '~types/feat/customer';

import Modal from '~components/atoms/Modal';
import BranchesDetailsForm from '../BranchesDetailsForm';
import ActionButton from '~components/atoms/ActionButton';
import Text from '~components/atoms/Text';
import CustomClipLoader from '~components/atoms/CustomClipLoader';

import { BranchStatusEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_branchesDetailsModal.module.scss';
import { TEditBranchDetailsReduxParams } from '~types/feat/branch';

const BranchesDetailsModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.branch.modals.branchDetailsModalIsOpen);
    const isEditing = useAppSelector(state => state.branch.modals.isEditing);
    const isLoading = useAppSelector(state => state.branch.loadings.editBranchDetails);
    const editBranchDetailsError = useAppSelector(state => state.branch.errors.editBranchDetails);
    const branchDetails = useAppSelector(state => state.branch.selectedBranch);

    const userAccess = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = !!userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.CustomerManagement);

    if (!branchDetails) return null;

    const setIsEditing = (isEditMode: boolean) => dispatch(combinedActions.branchSetBranchDetailsModalIsEditing(isEditMode));

    const handleModalOnClose = () => {
        setIsEditing(false);
        dispatch(combinedActions.branchResetEditBranchDetailsState());
        dispatch(combinedActions.branchSetBranchDetailsModalIsOpen(false));
    };

    const handleOnSubmit = (data: TEditBranchDetailsReduxParams) => isEditing && dispatch(combinedActions.branchEditBranchDetailsAttempt(data));

    return (
        <Modal
            title='Branch Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <div className={Styles.subcontainer}>
                {(hasEditAccess && branchDetails.status !== BranchStatusEnum.Deleted)
                    && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <ActionButton
                                label={isEditing ? 'Disable editing' : 'Enable editing'}
                                onClick={() => setIsEditing(!isEditing)}
                            />
                        </div>
                    )
                }

                <BranchesDetailsForm
                    submitButtonLabel='Update'
                    actionButtonIsLoading={isLoading}
                    actionButtonClassName={Styles['form-action-button-disabled']}
                    actionButtonIsDisabled={!isEditing}
                    onSubmit={handleOnSubmit}
                    inputIsDisabled={!isEditing}
                    error={editBranchDetailsError}
                    isEditing={isEditing}
                    initialBranchDetails={branchDetails}
                />
            </div>
        </Modal>
    );
};

export default BranchesDetailsModal;
